import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogBookEntry } from '../../model/logbook-entry';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { NetworkService } from '../../service/network.service';

@Injectable({
  providedIn: 'root'
})
export class AkitaMissionLogBookHttpService extends GenericAkitaHTTPService<LogBookEntry> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'LogBookEntry',
        limit: '50',
        orderBy: '!dateIssued',
      }
    };
    super(http, networkService, '/v2/entities/', 'logbookentry', options);
  }
}
